<template>
  <div v-if="init" class="amap-center-tool">
    <Teleport to="#amap-control">
      <div class="center-control">
        <el-tooltip content="回到中心" effect="dark" placement="left">
          <img src="@p-v/packages/Map/AMapChart/assets/center.png" alt="回到中心" class="center-icon" @click="backToCenter" />
        </el-tooltip>
      </div>
    </Teleport>
  </div>
</template>

<script lang="ts" setup>
import { ref, inject, watch } from "vue"
import { ElTooltip } from "element-plus"

defineOptions({
  name: "AMapCenterLayer",
})

const init = ref<boolean>(false)
const emit = defineEmits(["center-reset"])

// 从父组件注入地图实例和中心点
const amap = inject<any>("amap")
const centerPoint = inject<any>("centerPoint")

// 初始中心点坐标
const initialCenter = ref<{ lng: number; lat: number } | null>(null)

// 监听地图实例变化
watch(
  () => amap.value,
  map => {
    if (map) {
      // 初始化回到中心工具
      console.log("初始化回到中心工具", map)
      init.value = true

      // 记录初始中心点坐标
      if (centerPoint.value) {
        initialCenter.value = { ...centerPoint.value }
      } else {
        // 如果没有注入centerPoint，则从地图当前中心获取
        const center = map.getCenter()
        initialCenter.value = {
          lng: center.getLng(),
          lat: center.getLat(),
        }
      }
    }
  },
  { immediate: true },
)

// 回到地图中心点
const backToCenter = () => {
  if (!amap.value || !initialCenter.value) return

  // 设置地图中心点
  amap.value.setCenter([initialCenter.value.lng, initialCenter.value.lat], true)

  // 发送事件
  emit("center-reset", initialCenter.value)
}

// 暴露方法
defineExpose({
  backToCenter,
})
</script>

<style scoped>
.amap-center-tool {
  display: contents;
}

.center-control {
  background-color: white;
  padding: 5px;
  border-radius: 4px;
  margin-bottom: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  img {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
}

.center-control:hover {
  background-color: #f0f0f0;
}

.center-control:active {
  background-color: #e0e0e0;
}
</style>
